<template>
  <div class="layout-header-tabs">
    <div class="fixed-tabs-wrap">
      <div class="portal-wrap theme-text"
           :class="{'is-active': tabObj.current === portalObj.name}"
           @click="switchToPortal">
        <MainTabMenu :context-item="portalObj"
                     @handleRefresh="refreshCurrentTab"
                     @contextmenu.native.prevent="event => handleContextmenu(event, portalObj)"></MainTabMenu>
      </div>
    </div>
    <div class="tabs-pane-wrap">
      <el-tabs type="card" v-model="tabObj.current" @tab-remove="removeMainTab">
        <el-tab-pane v-for="option in tabFreeOptions"
                     :key="option.name + (option.stamp || '')"
                     :name="option.name"
                     :closable="option.closable">
          <MainTabMenu slot="label"
                       :context-item="option"
                       @handleRefresh="refreshCurrentTab"
                       @contextmenu.native.prevent="event => handleContextmenu(event, option)"></MainTabMenu>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations, mapGetters} from 'vuex'
import MainTabMenu from './elements/layout/MainTabMenu'
import routeUtils from '../util/routeUtils'
import fragmentUtils from '../util/fragmentUtils'
import Sortable from 'sortablejs'
export default {
  name: 'LayoutHeaderTabs',
  components: {
    MainTabMenu
  },
  computed: mapState({
    portalObj: state => state.layout.main.portal,
    tabObj: state => state.layout.main.tab,
    tabFreeOptions: function () {
      return this.tabObj.options.filter(option => option.name !== this.portalObj.name)
    }
  }),
  methods: {
    ...mapMutations(['removeMainTab']),
    ...mapMutations(['removeMainActiveTab']),
    ...mapMutations(['removeMainOtherTabs']),
    ...mapMutations(['removeMainLeftTabs']),
    ...mapMutations(['removeMainRightTabs']),
    ...mapMutations(['removeMainAllTabs']),
    ...mapGetters(['getMainActiveTab']),
    switchToPortal () {
      this.tabObj.current = this.portalObj.name
    },
    refreshCurrentTab () {
      this.$emit('refreshCurrentTab')
    },
    mainTabChanged () {
      let activeTab = this.getMainActiveTab()
      if (activeTab) {
        let $route = this.$route
        let currentPath = routeUtils.getCurrentRoutePath(this, $route)
        let forwardPath = currentPath + (fragmentUtils.resolvePath(activeTab.name) || activeTab.path)
        // 防止顶层跳转时回退
        if ($route.path.startsWith(forwardPath + '/')) {
          return
        }
        let matchId = routeUtils.getRouteMatchId(this, $route)[0]
        if (matchId !== activeTab.name) {
          if (currentPath.startsWith($route.path)) {
            this.$router.replace({ path: forwardPath })
          } else {
            this.$router.push({ path: forwardPath })
          }
        }
      }
    },
    handleContextmenu (event, option) {
      this.$contextmenu({
        items: [
          {
            label: '刷新标签页',
            icon: 'el-icon-refresh',
            disabled: option.name !== this.tabObj.current,
            onClick: this.refreshCurrentTab
          }, {
            label: '关闭标签页',
            icon: 'el-icon-document-delete',
            divided: true,
            disabled: !option.closable,
            onClick: () => {
              this.removeMainTab(option.name)
            }
          }, {
            label: '关闭其它标签页',
            icon: 'el-icon-document-delete',
            onClick: this.removeMainOtherTabs
          }, {
            label: '关闭左侧标签页',
            icon: 'el-icon-document-delete',
            onClick: this.removeMainLeftTabs
          }, {
            label: '关闭右侧标签页',
            icon: 'el-icon-document-delete',
            divided: true,
            onClick: this.removeMainRightTabs
          }, {
            label: '关闭全部标签页',
            icon: 'el-icon-document-delete',
            onClick: this.removeMainAllTabs
          }
        ],
        event,
        customClass: 'layout-header-context-menu',
        minWidth: 180,
        zIndex: 2999
      })
    },
    createTabsSort () {
      this.tabsSort = Sortable.create(this.$el.querySelector('.tabs-pane-wrap .el-tabs__nav'), {
        handle: '.el-tabs__item',
        onEnd: ({ item, newIndex, oldIndex }) => {
          let fromTab = this.tabFreeOptions[oldIndex]
          let toTab = this.tabFreeOptions[newIndex]
          let tabOptions = this.tabObj.options
          let fromTabIndex = tabOptions.findIndex(option => option === fromTab)
          let toTabIndex = tabOptions.findIndex(option => option === toTab)
          if (fromTabIndex !== toTabIndex) {
            tabOptions.splice(fromTabIndex, 1)
            tabOptions.splice(toTabIndex, 0, fromTab)
          }
        }
      })
    }
  },
  mounted () {
    this.createTabsSort()
  },
  beforeDestroy () {
    if (this.tabsSort) {
      this.tabsSort.destroy()
    }
  },
  watch: {
    'tabObj.current': function () {
      this.mainTabChanged()
    }
  }
}
</script>

<style lang="scss">
  .layout-header-tabs {
    display: flex;
    & > .fixed-tabs-wrap {
      flex: none;
      padding-left: 10px;
      & > .portal-wrap {
        position: relative;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        margin-right: 10px;
        transition-property: padding-left,padding-right;
        transition-duration: .3s;
        .main-tab-menu {
          & > .menu-text {
            display: none;
            color: #303133;
          }
          i {
            width: 16px;
            height: 16px;
            font-size: 16px;
            line-height: 16px;
            border-radius: 50%;
            vertical-align: -1px;
            opacity: .8;
          }
        }
        &.is-active {
          padding-left: 15px;
          padding-right: 15px;
          background-color: #F0F2F5;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          margin-right: -1px;
          z-index: 10;
          .main-tab-menu {
            & > .menu-text {
              display: inline;
            }
            i {
              margin-right: 5px;
            }
          }
        }
      }
    }
    & > .tabs-pane-wrap {
      flex: auto;
      .el-tabs {
        position: relative;
        height: 100%;
        & > .el-tabs__header {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin-bottom: 0;
          border-bottom: none;
          box-sizing: border-box;
          & > .el-tabs__nav-wrap {
            height: 100%;
            &.is-scrollable {
              padding: 0 24px;
              .el-tabs__nav-prev,
              .el-tabs__nav-next {
                width: 24px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 12px;
                box-sizing: border-box;
                i {
                  color: #303133;
                  font-weight: bold;
                }
              }
              .el-tabs__nav-prev {
                box-shadow: 1px 0 5px rgba(0,0,0,.05);
              }
              .el-tabs__nav-next {
                box-shadow: -1px 0 5px rgba(0,0,0,.05);
              }
              .el-tabs__nav-scroll {
                .el-tabs__nav {
                  .el-tabs__item {
                    &:first-child {
                      margin-left: 0;
                      &:before {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
            .el-tabs__nav-scroll {
              height: 100%;
              .el-tabs__nav {
                border: none;
                border-radius: 0;
                .el-tabs__item {
                  height: 30px;
                  color: #303133;
                  font-size: 12px;
                  line-height: 30px;
                  border: none;
                  padding-left: 10px;
                  padding-right: 10px;
                  margin-left: 1px;
                  &:before {
                    content: '';
                    position: absolute;
                    left: -1px;
                    top: 50%;
                    width: 1px;
                    height: 10px;
                    margin-top: -5px;
                    background-color: #DCDFE6;
                  }
                  &:last-child {
                    &:after {
                      content: '';
                      position: absolute;
                      right: -1px;
                      top: 50%;
                      width: 1px;
                      height: 10px;
                      margin-top: -5px;
                      background-color: #DCDFE6;
                    }
                  }
                  &.is-closable {
                    .el-icon-close {
                      top: -1px;
                      width: 14px;
                      height: 14px;
                      line-height: 14px;
                      margin-left: 0;
                    }
                    &.is-active,
                    &:hover {
                      .el-icon-close {
                        color: #303133;
                        opacity: 1;
                        background-color: transparent;
                      }
                    }
                  }
                  &.is-active {
                    background-color: #F0F2F5;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    &:before,
                    &:after {
                      background-color: transparent!important;
                    }
                    & + .el-tabs__item {
                      &:before {
                        background-color: transparent!important;
                      }
                    }
                  }
                  i {
                    display: none!important;
                  }
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          display: none;
          visibility: hidden;
        }
      }
    }
  }
  .layout-header-context-menu {
    .menu_item {
      font-size: 12px!important;
      &.menu_item__available {
        &:hover {
          color: #303133!important;
          background-color: #f9f9f9!important;
        }
      }
    }
  }
</style>
